<h2 mat-dialog-title class="cca__title" autoTranslate>Fechar turno atual?</h2>

<mat-dialog-content class="cca__content">
    <p class="cca__lead" autoTranslate>
        Algumas pessoas selecionadas já estão com turno aberto. Marque quem deve ter o turno atual encerrado antes de
        iniciar o novo — quem não for marcado fica alocado nos dois ao mesmo tempo.
    </p>

    <section class="cca__group" *ngFor="let row of rows">
        <div class="cca__group-head">
            <span class="cca__group-label">{{ row.label }}</span>
            <div class="cca__group-actions">
                <button type="button" mat-button (click)="toggleAll(row, true)" autoTranslate>Marcar todos</button>
                <button type="button" mat-button (click)="toggleAll(row, false)" autoTranslate>Desmarcar todos</button>
            </div>
        </div>
        <label class="cca__person" *ngFor="let person of row.people">
            <mat-checkbox [(ngModel)]="person.selected"></mat-checkbox>
            <span class="cca__person-name">{{ person.name }}</span>
            <span class="cca__person-tag" *ngIf="!person.isTriggering" autoTranslate>também nesta equipe</span>
        </label>
    </section>

    <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
        <mat-label autoTranslate>Horário de encerramento</mat-label>
        <input matInput type="datetime-local" [(ngModel)]="endedAtLocal" />
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end" class="cca__actions">
    <button mat-stroked-button type="button" (click)="cancel()">
        <span autoTranslate>Cancelar</span>
    </button>
    <button mat-button type="button" (click)="skip()">
        <span autoTranslate>Continuar sem fechar</span>
    </button>
    <button mat-flat-button color="primary" type="button" [disabled]="!hasAnySelected" (click)="confirm()">
        <span autoTranslate>Fechar e continuar</span>
    </button>
</mat-dialog-actions>
